export default {
  supplierpartners: {
    subtitle: "شركاء الموردين",

    title1: "موثوق من قبل",
    title2: "أفضل الموردين",

    desc:
      "من المنتجين المحليين إلى الموزعين الكبار، يثق الموردون في MAHAL لتنمية أعمالهم والوصول إلى المطاعم بسهولة.",

    metric1: "مورد نشط",
    metric2: "مطعم مخدوم",
    metric3: "طلبات بالجملة",
    metric3num: "يوميًا",

    cta: "انضم كمورد",
  },
};